<template>
  <div class="content">
    <div class="top">
      <!-- <div class="phone">
        <div class="phoneItem">
          <span style="font-size: 16px">{{ $t("footer.vpnHotline") }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 16px">{{
            $t("footer.passwordHotline")
          }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 16px">{{ $t("footer.networkHotline") }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 16px">{{ $t("footer.emailHotline") }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 16px">{{ $t("footer.stationHotline") }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 16px">{{ $t("footer.accountHotline") }}</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966342</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966502</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966342</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966342</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966342</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">巴南龙洲湾校区</span
          ><span style="font-size: 18px; font-weight: bold">023-85966342</span>
        </div>

        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84832068</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84833333</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84832068</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84832068</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84832068</span>
        </div>
        <div class="phoneItem">
          <span style="font-size: 14px; color: #666666">沙坪坝井口校区</span
          ><span style="font-size: 18px; font-weight: bold">023-84832068</span>
        </div>
      </div> -->
      <div class="address">
        <div class="left">
          <span>{{ $t("footer.organizer") }}</span
          ><span>{{ $t("footer.address") }}</span
          ><span>{{ $t("footer.technical") }}</span
          ><span>{{ $t("footer.suggestion") }}</span>
        </div>
        <div class="right">
          <img
            src="@/assets/img/code1.jpg"
            style="width: 100px; height: 100px; margin-right: 5px"
            alt=""
          />
          <span>{{ $t("footer.serviceAccount") }}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <span>{{ $t("footer.rights") }} All Rights Reserved </span>
      <a v-for="ba in beian" :key="ba.value" :href="ba.value">{{ ba.name }}</a>
    </div>
  </div>
</template>
<script>
import request from "@/api/request";
export default {
  name: "footBar",
  data() {
    return {
      beian: [],
    };
  },
  computed: {
    beianText() {
      return this.beian.map((item) => item.name).join(" ");
    },
  },
  mounted() {
    this.getBeian();
  },
  methods: { 
    getBeian() {
      request({
        url: `/api/sys/dict/all`,
        method: "get",
      })
        .then((res) => {
          // 过滤出证件类型
          this.beian =
            res?.find((item) => item.type === "beian")?.dictDatas || [];
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  // height: 200px;
  display: flex;
  flex-direction: column;
  background: #f5f7fb;
  color: #666;
  font-size: 14px;
  margin-top: 25px;
  .top {
    // height: 90%;
    // background: #f5f7fb;
    padding: 30px 10%;
    .phone {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; /* 两列 */
      gap: 15px;
      height: 50%;
      border-bottom: 1px solid #dfdfdf;
      padding-bottom: 15px;
      .phoneItem {
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
      }
    }
    .address {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 50%;
      // padding: 15px 0;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        line-height: 36px;
        // color: #666666;
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          // color: #666666;
          font-size: 14px;
        }
      }
    }
  }
  .bottom {
    height: 40px;
    background: #e7ecf5;
    // color: #666666;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border-top: 1px solid #E7ECF5;
    // padding: 22px 0;
    a {
      color: #666666;
      font-size: 14px;
    }
    * {
      margin: 0 10px;
    }
  }
}
</style>
